import { PermissionsMap } from './permission.types';

export interface authModel {
    save_login: boolean;
    access_token: string;
    access_token_expires: string;
    refresh_token: string;
    refresh_token_expires: string;
    api_key?: string;
    api_key_expires?: string;
    device_token?: string;
    username: string;
    level: string;
    permissions?: PermissionsMap;
}

export interface apiAuthModel {
    access_token: string;
    expires_in: number;
    token_type: string;
    refresh_token: string;
    expires: {
        date: string;
        timezone_type: number;
        timezone: string;
    };
    refresh_token_expires: {
        date: string;
        timezone_type: number;
        timezone: string;
    };
    one_time_password: boolean;
}

export interface apiKeyModel {
    expires: {
        date: string;
        timezone_type: number;
        timezone: string;
    };
    apiKey: string;
}

export interface storageApiKey {
    api_key: string;
    api_key_expires: string;
}

export interface authUserModel {
    id: number;
    status: boolean;
    Company: {
        id: number;
        name: string;
        logo: string;
    };
    Companies: {
        id: number;
        name: string;
    }[];
    Person: {
        id: number;
    };
    Employee: {
        id: number;
    };

    Permissions: PermissionsMap;
}

export class authStorage {
    /**
     * @param auth The response of the API token call
     * @param saveLogin Persist login state
     * @param deviceToken Device token string
     * @param username Username
     * @param level Access level
     * @param permissions Optional snapshot of permissions
     */
    public static createapiAuth(
        auth: apiAuthModel,
        saveLogin: boolean,
        deviceToken: string,
        username: string,
        level: string,
        permissions?: PermissionsMap
    ): string {
        const storageData = {
            'save_login': saveLogin,
            'access_token': auth.access_token,
            'access_token_expires': auth.expires.date,
            'refresh_token': auth.refresh_token,
            'refresh_token_expires': auth.refresh_token_expires.date,
            'device_token': deviceToken,
            'username': username,
            'level': level,
            'permissions': permissions || undefined
        };
        return JSON.stringify(storageData);
    }

    public static createapiKey(apikey: apiKeyModel): string {
        const storageData = {
            'api_key': apikey.apiKey,
            'api_key_expires': apikey.expires.date
        };
        return JSON.stringify(storageData);
    }

    public static createAuthUser(user: authUserModel): string {
        return JSON.stringify(user);
    }
}
